import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "waybills-table-column-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs_button = _resolveComponent("bs-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_bs_button, {
      size: "small",
      onClick: _ctx.onRequestForPayment
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Запросить ")
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}